import { RadioCards } from '../catalyst/radio-cards'

/** A large tap-friendly "Same as last time" shortcut. */
export function SameAsLast({ label, onClick }: { label: string; onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex min-h-11 w-full items-center gap-2 rounded-lg bg-emerald-50 px-4 py-2 text-left text-sm/6 font-medium text-emerald-800 ring-1 ring-emerald-600/20 hover:bg-emerald-100 dark:bg-emerald-900/20 dark:text-emerald-300 dark:ring-emerald-500/20"
    >
      <span aria-hidden="true">↺</span>
      <span>Same as last time: {label}</span>
    </button>
  )
}

/** One of a few choices as big buttons that wrap on a phone (a Catalyst RadioCards group). */
export function ChoiceButtons<T extends string>({
  label,
  value,
  options,
  onChange,
}: {
  /** The question; it names the group for screen readers too. */
  label: string
  value: T | ''
  options: readonly { value: T; label: string }[]
  onChange: (value: T) => void
}) {
  return <RadioCards layout="wrap" label={label} value={value} options={options} onChange={onChange} />
}

/**
 * A yes/no question with no answer until the grower gives one. Attestations ("label followed",
 * "PHI checked") must never default to either side: an unanswered box recorded as "No" is a false
 * statement in the record, and one recorded as "Yes" is worse.
 */
export function YesNo({ label, value, onChange }: { label: string; value: unknown; onChange: (answer: boolean) => void }) {
  return (
    <ChoiceButtons
      label={label}
      value={value === true ? 'yes' : value === false ? 'no' : ''}
      options={[
        { value: 'yes', label: 'Yes' },
        { value: 'no', label: 'No' },
      ]}
      onChange={(v) => onChange(v === 'yes')}
    />
  )
}

/** How an attestation reads on the review step. */
export const answerLabel = (value: unknown) => (value === true ? 'Yes' : value === false ? 'No' : 'Not answered')
